import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { RefundOrder } from '../../models/RefundOrder';
import { RefundCard } from './RefundCard';

interface RefundCardListProps {
  orders: RefundOrder[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  selectedColumns?: string[];
}

export const RefundCardList = ({
  orders,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  selectedColumns,
}: RefundCardListProps) => {
  const { t } = useTranslation('refundsModule');

  const renderCard = (props: RenderItemProps<RefundOrder>) => (
    <RefundCard order={props.item} selectedColumns={selectedColumns} />
  );

  const getKey = (order: RefundOrder) => order.order_id;

  return (
    <VirtualList
      data={orders}
      renderItem={renderCard}
      itemKey={getKey}
      estimateItemHeight={130}
      height="calc(100vh - 140px)"
      gap={0}
      emptyMessage={t('empty.no_data.description')}
      className="rounded-lg shadow-sm"
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
